<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title">{{title}}</h4>
    </div>
    <div class="modal-body">
        <p [innerHtml]="body"></p>
        <p *ngIf="extra" class="{{cssClass}}">{{extra}}</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-success" (click)="activeModal.close(true)">Yes</button>
        <button type="button" class="btn btn-danger" (click)="activeModal.close(false)">No</button>
    </div>
</div>
